<template>
  <header class="js-header">
    <div class="top-bar">
      <div class="nums" style="display: block;"></div>
      <button
        class="navbar-toggle js-open-nav"
        type="button"
        @click="togShow('menu')"
        :class="{active:shows==1}"
      >
        <div class="icon-bar"></div>
        <div class="icon-bar"></div>
        <div class="icon-bar"></div>
      </button>
      <div class="logo-box">
        <a href="/">
          <img :src="logoUrl" />
        </a>
      </div>
      <div
        class="pull-right search-box js-search-cancel js-hmt-detection"
        data-detection="首页-搜索按钮,点击,点击"
        @click="togShow('search')"
      >
        <i class="icon icon-search"></i>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: "headerBar",
  data() {
    return {
      menuBarToggle: false,
      shows: 0,
      logoUrl: process.env.BASE_URL + "img/logo.png"
    };
  },
  props: {},
  created() {},
  methods: {
    togShow: function(value) {
      if (value === "menu") {
        if (!this.menuBarToggle) {
          this.menuBarToggle = true;
          this.shows = 1;
          this.$emit("menuToggle", true);
        } else {
          this.menuBarToggle = false;
          this.$emit("menuToggle", false);
          this.shows = 0;
        }
      } else if (value === "search") {
        this.$emit("searchToggle", true);
      }
    }
  }
};
</script>

<style scoped>
header {
  position: relative;
}
.top-bar {
  height: 45px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}
.navbar-toggle {
  width: 2.7rem;
  height: 44px;
  background: #fff;
  text-align: center;
  padding: 0;
  margin: 0;
  position: absolute;
  border: none;
  cursor: pointer;
}

.navbar-toggle .icon-bar {
  width: 1.2rem;
  height: 1px;
  background: #333;
  margin: 0 auto 0.35rem;
}

.navbar-toggle.active .icon-bar {
  position: absolute;
  left: 50%;
  margin-left: -0.6rem;
}

@keyframes fadeRotateRight {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes fadeRotateLeft {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(-45deg);
  }
}

.navbar-toggle.active .icon-bar:nth-child(1) {
  -webkit-animation: fadeRotateRight 0.2s ease both;
  animation: fadeRotateRight 0.2s ease both;
}

.navbar-toggle.active .icon-bar:nth-child(2) {
  display: none;
}

.navbar-toggle.active .icon-bar:nth-child(3) {
  -webkit-animation: fadeRotateLeft 0.2s ease both;
  animation: fadeRotateLeft 0.2s ease both;
}

.logo-box {
  position: absolute;
  left: 35%;
  margin-top: 0.375rem;
}

.logo-box img {
  width: 110px;
}

.pull-right {
  float: right;
}

.search-box {
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.icon {
  display: inline-block;
  vertical-align: text-bottom;
  background: url(../assets/icon.png) no-repeat;
  width: 15px;
  height: 16px;
  cursor: pointer;
  background-size: 250px 300px;
}
.icon-search {
  background-position: -30px 14px;
  width: 45px;
  height: 45px;
}

img {
  object-fit: cover;
  vertical-align: top;
}

.navbar-toggle .icon-bar:last-child {
  margin-bottom: 0;
}
</style>